module.exports = {
    "skincare": {
        "1": {
            "201":"脂性肌・乾燥肌が混在する敏感肌",
            "202":"乾燥肌強めの敏感肌",
            "203":"敏感肌",
            "204":"乾燥肌が原因の敏感肌",
            "205":"乾燥肌ベースの敏感肌",
            "206":"乾燥肌優位の混合肌",
            "207":"アレルギー疾患ベースの混合肌",
            "208":"混合肌",
            "209":"乾燥肌",
            "210":"生活スタイルが原因の乾燥肌",
            "211":"ターンオーバーに起因する乾燥肌",
            "212":"健康肌",
            "213":"脂性肌",
            "214":"脂性肌・ニキビ肌",
            "215":"混合肌",
            "216":"脂性肌",
            "217":"正常肌",
            "218":"脂性肌優位の混合肌",
            "219":"ホルモン関与の脂性肌",
        },
        "4": {
            "0": "女性",
            "1": "男性"
        },
        "5": {
            "0": "10代",
            "1": "20~25歳",
            "2": "26~30歳",
            "3": "31~35歳",
            "4": "36~40歳",
            "5": "41歳以上"
        },
        "7": {
            "0": "ナチュラルコスメ",
            "1": ""
        },
        "8": {
            "0": "~1000円",
            "1": "~3000円",
            "2": "~5000円",
            "3": "価格気にしない"
        },
        "9": {
            "0": "ニキビ",
            "1": ""
        },
        "10": {
            "0": "メイク(しっかり)",
            "1": "メイク(普通)",
            "2": "メイク(薄め)"
        },
        "11": {
            "0": "美肌",
            "1": "エイジングケア",
            "2": "毛穴",
            "3": "保湿"
        }
    },
    "makeup": {
        "1": {
            "201":"脂性肌・乾燥肌が混在する敏感肌",
            "202":"乾燥肌強めの敏感肌",
            "203":"敏感肌",
            "204":"乾燥肌が原因の敏感肌",
            "205":"乾燥肌ベースの敏感肌",
            "206":"乾燥肌優位の混合肌",
            "207":"アレルギー疾患ベースの混合肌",
            "208":"混合肌",
            "209":"乾燥肌",
            "210":"生活スタイルが原因の乾燥肌",
            "211":"ターンオーバーに起因する乾燥肌",
            "212":"健康肌",
            "213":"脂性肌",
            "214":"脂性肌・ニキビ肌",
            "215":"混合肌",
            "216":"脂性肌",
            "217":"正常肌",
            "218":"脂性肌優位の混合肌",
            "219":"ホルモン関与の脂性肌",
        },
        "50": {
            "0": "健康肌",
            "1": "色むら",
            "2": "小ジワ",
            "3": "毛穴"
        },
        "51": {
            "0": "ツヤ",
            "1": "マット"
        },
        "52": {
            "0": "輪郭:卵型",
            "1": "輪郭:丸型",
            "2": "輪郭:面長",
            "3": "輪郭:ベース型",
            "4": "輪郭:三角",
            "5": "輪郭:四角"
        },
        "53": {
            "0": "遠心+上重心",
            "1": "遠心+下重心",
            "2": "求心+上重心",
            "3": "求心+下重心",
            "4": "黄金比"
        },
        "54": {
            "0": "おでこ:丸みがある",
            "1": "おでこ:ふつう",
            "2": "おでこ:平ら"
        },
        "55": {
            "0":"彫り:深め",
            "1":"彫り:浅め"
        },
        "56": {
            "0":"あご:出ている",
            "1":"あご:ふつう",
            "2":"あご:ない"
        },
        "57": {
            "0": "頬骨:気になる",
            "1": "頬骨:気にならない"
        }
    }
}